export default __webpack_public_path__ + "static/media/ashutosh.da86b195.jpg";